import type { Stop } from '@getcircuit/schema'

import type { ClientContext } from '../../types'

type BaseImportQueriesParams = {
  planId?: string
  queries: Array<Partial<Stop>>
}

type ImportQueriesParamsAndUserId = BaseImportQueriesParams & {
  userId: string
}

type ImportQueriesParamsAndTeamId = BaseImportQueriesParams & {
  teamId: string
}

type ImportQueriesParams =
  | ImportQueriesParamsAndTeamId
  | ImportQueriesParamsAndUserId

type ImportQueryError = {
  rule: string
  field: string
  message: string
}

type ImportQueriesResponse = {
  stops: Stop[]
  planId: string
  teamId: string
  errors?: ImportQueryError[]
  message?: string
  stack?: string
  ids: {
    team: string
    plan: string
  }
}

/**
 * Documentation: https://www.notion.so/circuit/Import-d64898e3975a4774ad926c59091ef342
 */

export function importQueries(
  context: ClientContext,
  params: ImportQueriesParams,
) {
  return context.request<ImportQueriesResponse>('/import', {
    method: 'POST',
    withAuth: true,
    json: params
      ? {
          ...params,
          project: context.env.FIREBASE_ENV === 'production' ? 'teams' : 'dev',
        }
      : undefined,
  })
}
